var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors, fontWeights, spacing } from '../../../../defaultTheme';
import useWindowSize from '../../../customHooks/useWindowWidth';
const TD = styled.td `
  text-align: ${({ align }) => align || 'left'};
  padding: ${spacing.medium}px ${spacing.large}px;
  .DataTable__cell-label {
    display: none;
  }
  ${({ isCardTable }) => isCardTable && `border-bottom: 1px solid ${colors.lightGrey};`}
  ${({ breakpoint, hideInMobile, isPrimaryCell }) => {
    return (breakpoint &&
        `
      @media (max-width: ${breakpoint}px) {
        border: none;
        padding: 4px 12px 12px;
        display: ${hideInMobile ? 'none' : 'block'};
        ${isPrimaryCell
            ? `
            position: absolute;
            right: 0;
            top: 12px;
            font-weight: ${fontWeights.bold};
        `
            : `
            .DataTable__cell-label {
              display: block;
              font-weight: ${fontWeights.bold};
            }
        `}
      }
    `);
}}
`;
export const TableCellContent = ({ children }) => {
    return typeof children === 'object' && 'value' in children ? (_jsx("div", { children: children.value })) : (_jsx("div", { children: children }));
};
const TableCell = (_a) => {
    var { className, cellData, breakpoint = 0, isCardTable, label } = _a, props = __rest(_a, ["className", "cellData", "breakpoint", "isCardTable", "label"]);
    const { width } = useWindowSize();
    return (_jsxs(TD, Object.assign({}, props, { className: className, breakpoint: breakpoint, hideInMobile: cellData.hideInMobile, isCardTable: isCardTable, isPrimaryCell: cellData.isPrimaryCell, align: cellData.align, colSpan: cellData.colspan || 1, as: breakpoint && width < breakpoint ? 'li' : '' }, { children: [label && !isCardTable && (_jsx("div", Object.assign({ className: "DataTable__cell-label" }, { children: _jsx(TableCellContent, { children: label }) }))), _jsx(TableCellContent, { children: cellData })] })));
};
export const TableRowIcon = styled(TableCell) `
  padding: 0 12px 0 0;
  width: 30px;
  & * {
    vertical-align: middle;
  }
  ${({ breakpoint }) => breakpoint &&
    `
      @media (max-width: ${breakpoint}px) {
        text-align: right;
        position: absolute;
        top: 45%;
        right: 0;
        border: none;
      }
    `}
`;
export default TableCell;
//# sourceMappingURL=TableCell.js.map